import React from "react";
import PropTypes from "prop-types";

import { Box, IconButton, TextField } from "@mui/material";
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';

const InputField = ({ highlight_color, openColorPicker, onChange }) => {

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        value={highlight_color}
        onChange={onChange}
        color="warning"
        inputProps={{ 
          readOnly: true,
          style: { cursor: 'pointer' }
        }}
        onClick={openColorPicker}
        InputProps={{
          startAdornment: (
            <Box
              sx={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                backgroundColor: highlight_color,
                mr: 1,
              }}
            />
          ),
        }}
        sx={{
          mr: 1,
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.23) !important',
              borderWidth: '1px !important'
            }
          }
        }}
      />
      <IconButton
        size="small"
        sx={{ mx: 0.5 }}
        onClick={openColorPicker}
        title="Open color picker"
      >
        <PaletteOutlinedIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Box>
  );
};

InputField.propTypes = {
  highlight_color: PropTypes.string,
  openColorPicker: PropTypes.func,
  onChange: PropTypes.func,
};

export default InputField;
